import ImageIcon from '@mui/icons-material/Image';
import React, {useState} from 'react';
import {API_BASE} from '../config';

export const photoUrl = (path) => /^https?:\/\//i.test(path)
    ? path : `${API_BASE.replace(/\/$/, '')}/${path.replace(/^\/+/, '')}`;

export function GalleryImage({src, alt, ...props}) {
    const [failed, setFailed] = useState(false);
    return failed ? (
        <span className="gallery-unavailable" role="img" aria-label={alt}>
            <ImageIcon fontSize="large" />
            <span>Imagine indisponibilă</span>
        </span>
    ) : <img src={src} alt={alt} onError={() => setFailed(true)} {...props} />;
}

